import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { logInboxPlusExperimentData } from 'owa-mail-inbox-plus-store';
import { createLazyOrchestrator } from 'owa-bundling';
import { lazyLogFloodgateActivity } from 'owa-floodgate-feedback-view';
import { logUsage } from 'owa-analytics';

export const logIsFocusedOtherUserOrchestrator = createLazyOrchestrator(
    logInboxPlusExperimentData,
    'clone_logInboxPlusExperimentData',
    async actionMessage => {
        const logFloodgateActivity = await lazyLogFloodgateActivity.import();

        logFloodgateActivity('InboxPlusExperimentSession');

        if (isFocusedInboxEnabled()) {
            logUsage('InboxPlusDefaultTabs_FocusedOtherUser', {
                isCore: true,
            });
        } else {
            logUsage('InboxPlusDefaultTabs_InboxUser');
        }
    }
);
